/**
 * 越南	VN
 * 泰国	TH
 * 菲律宾	PH
 * 马来西亚	MY
 * 新加坡	SG
 * ID	印度尼西亚（Indonesia）
 * IN	印度（India）
 * EG	埃及（Egypt）
 * CN	中国（China） 
 * TR 土耳其
 */
      
function geoBlockedHandler() {
    const blockedCountries = ["ID", "IN", "EG", "CN", "TR"];
    const token = '0a54e83a614851';
    const getIPUrl = `https://api.ipinfo.io/lite/me?token=${token}`;
    fetch(getIPUrl)
    .then(res => res.json())
    .then(data => {
        if (blockedCountries.includes(data.country_code)) {
        window.location.href = "/pages/geo-blocked"; 
        }
    })
    .catch(err => {
        console.warn("IP 检测失败：", err);
    });
}

geoBlockedHandler();